import * as Yup from 'yup';
import { DealerManagementService } from 'src/services/dealer-management.service';
import FooterPrivacy from 'src/views/auth/components/baseTemplate/FooterPrivacy';
import { getBrandByDealerNumber } from 'src/utils/helpers';
import Input from 'src/components/forms/input';
import { IUser } from 'src/utils/interfaces/user';
import Spinner from 'src/components/ui/spinner';
import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import Notification, {
    NotificationType,
} from 'src/components/ui/notification/Notification';
import './styles.scss';

const validationSchema = Yup.object({
    dealerId: Yup.string()
        .trim()
        .required('This field is required')
        .matches(/^[A-Za-z0-9]{6}$/, 'Missing or incomplete search criteria.'),
});

const dealerGroupMaintenance = () => {
    const [showMessage, setShowMessage] = useState(false);
    const [isError, setIsError] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const navigate = useNavigate();
    const formik = useFormik({
        initialValues: {
            dealerId: '',
        },
        validationSchema,
        validateOnChange: false,
        onSubmit: async (values) => {
            setShowMessage(false);
            setIsLoading(true);
            const service = new DealerManagementService();

            try {
                const res = await service.getDealerGroups(values.dealerId);

                if (res.data) {
                    const dealersGroupState = {
                        dealerGroups: res.data,
                        dealerGroupSearch: values.dealerId,
                        isSuccess: false,
                    };
                    sessionStorage.setItem(
                        'dealerGroupState',
                        JSON.stringify(dealersGroupState),
                    );
                    navigate(
                        '/dashboard/systemadmin/dealer-group-maintenance/search',
                        {
                            state: dealersGroupState,
                        },
                    );
                }
            } catch (e: any) {
                setShowMessage(true);
                setIsError(true);
            } finally {
                setIsLoading(false);
            }
        },
    });
    const { values, errors, touched, handleSubmit, setFieldValue, handleBlur } =
        formik;
    let brand = 'vw';
    const currentDealers = useSelector((state: IUser) => {
        return state.currentDealers;
    });
    const dealerDataInfo = useSelector((state: IUser) => {
        return state.dealerDataInfo;
    });
    if (currentDealers && dealerDataInfo) {
        const { dealer } = dealerDataInfo;
        brand = getBrandByDealerNumber(dealer.brand, dealer.dealerNumber);
    }
    return (
        <div className='dashboard-content-wrapper'>
            <div className='dealer-group-maintenance dashboard-content-container'>
                <section className='o-content-section'>
                    {isError && (
                        <div className={''}>
                            <Notification
                                content={'The dealer number cannot be found.'}
                                type={NotificationType.ERROR}
                                visibility={showMessage}
                                setVisibility={() => {
                                    setShowMessage(false);
                                    setIsError(false);
                                }}
                            />{' '}
                        </div>
                    )}
                    <div className='page-title'>
                        <h5>Dealer Group Maintenance Search</h5>
                    </div>
                    <section className='c-form-section'>
                        <div className='c-form-section__content'>
                            <div className='o-fieldset__row u-mt-x-small u-mb-x-small'>
                                <div className='o-layout'>
                                    <div className='o-layout__item u-1/1 u-1/1@xs'>
                                        <p>
                                            Search for a Dealer Number to view
                                            and manage the dealer group,
                                            associated users, and permissions.
                                        </p>
                                    </div>
                                    <form
                                        className='o-layout__item u-1/1 u-1/1@xs'
                                        onSubmit={handleSubmit}
                                    >
                                        <div className='o-layout__item u-1/1 u-1/1@xs'>
                                            <div className='c-form-field'>
                                                <div className='c-form-field__box'>
                                                    <Input
                                                        labelName={
                                                            'Dealer Number:'
                                                        }
                                                        type={'text'}
                                                        name={'dealerId'}
                                                        maxlength={6}
                                                        handlerChange={(
                                                            e: React.ChangeEvent<HTMLInputElement>,
                                                        ) => {
                                                            setFieldValue(
                                                                'dealerId',
                                                                e.target.value.toUpperCase(),
                                                            );
                                                        }}
                                                        handlerBlur={handleBlur}
                                                        value={values.dealerId}
                                                        asErrors={
                                                            errors.dealerId
                                                        }
                                                        asTouched={
                                                            touched.dealerId
                                                        }
                                                        asSubmitError={
                                                            errors.dealerId
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='o-layout__item u-1/1 u-1/1@xs'>
                                            <div className='o-fieldset__row button-group'>
                                                <button
                                                    className={`c-btn btn--secondary ${brand}`}
                                                    type='submit'
                                                    disabled={isLoading}
                                                >
                                                    <span className='c-btn__text'>
                                                        {isLoading ? (
                                                            <Spinner />
                                                        ) : (
                                                            'Submit'
                                                        )}
                                                    </span>
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </section>
                    <div style={{ gridColumnStart: 2, marginTop: '40px' }}>
                        <FooterPrivacy />
                    </div>
                </section>
            </div>
        </div>
    );
};

export default dealerGroupMaintenance;
